import { defineComponent as V, openBlock as l, createElementBlock as o, mergeProps as i, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const M = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, k = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconFlagPennant"
}, L = /* @__PURE__ */ V({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: r } = m(a);
    return (p, t) => (l(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      u(p.$slots, "default"),
      e(r) === "bold" ? (l(), o("g", M, t[0] || (t[0] = [
        n("path", { d: "M243.94,92.67l-184-64A12,12,0,0,0,44,40V216a12,12,0,0,0,24,0V176.53l175.94-61.2a12,12,0,0,0,0-22.66ZM68,151.12V56.88L203.47,104Z" }, null, -1)
      ]))) : e(r) === "duotone" ? (l(), o("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M240,104,56,168V40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M242.63,96.44l-184-64A8,8,0,0,0,48,40V216a8,8,0,0,0,16,0V173.69l178.63-62.13a8,8,0,0,0,0-15.12ZM64,156.75V51.25L215.65,104Z" }, null, -1)
      ]))) : e(r) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M248,104a8,8,0,0,1-5.37,7.56L64,173.69V216a8,8,0,0,1-16,0V40a8,8,0,0,1,10.63-7.56l184,64A8,8,0,0,1,248,104Z" }, null, -1)
      ]))) : e(r) === "light" ? (l(), o("g", k, t[3] || (t[3] = [
        n("path", { d: "M242,98.33l-184-64A6,6,0,0,0,50,40V216a6,6,0,0,0,12,0V172.27l180-62.6a6,6,0,0,0,0-11.34ZM62,159.56V48.44L221.74,104Z" }, null, -1)
      ]))) : e(r) === "regular" ? (l(), o("g", h, t[4] || (t[4] = [
        n("path", { d: "M242.63,96.44l-184-64A8,8,0,0,0,48,40V216a8,8,0,0,0,16,0V173.69l178.63-62.13a8,8,0,0,0,0-15.12ZM64,156.75V51.25L215.65,104Z" }, null, -1)
      ]))) : e(r) === "thin" ? (l(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M241.31,100.22l-184-64A4,4,0,0,0,52,40V216a4,4,0,0,0,8,0V170.84l181.31-63.06a4,4,0,0,0,0-7.56ZM60,162.37V45.63L227.82,104Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
